import "./editar_cadastro.6a33cc6e.js";


      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2ac2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2ac2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
// src/editar-cadastro.js

var $cpXHg = parcelRequire("cpXHg");

var $gGcib = parcelRequire("gGcib");
document.addEventListener('DOMContentLoaded', ()=>{
    // --- Elementos do Formulário ---
    const editarCadastroForm = document.getElementById('editar-cadastro-form');
    const nomeEditarInput = document.getElementById('nome-editar');
    const telefoneEditarInput = document.getElementById('telefone-editar');
    const telefoneInvalidoDiv = document.getElementById('telefone-invalido-editar');
    const cpfEditarInput = document.getElementById('cpf-editar');
    const cpfInvalidoDiv = document.getElementById('cpf-invalido-editar');
    const empresaEditarInput = document.getElementById('empresa-editar');
    const cnpjEditarInput = document.getElementById('cnpj-editar');
    const cnpjInvalidoDiv = document.getElementById('cnpj-invalido-editar');
    const emailEditarInput = document.getElementById('email-editar');
    const emailInvalidoDiv = document.getElementById('email-invalido-editar');
    const tipoParticipanteRadios = document.querySelectorAll('input[name="tipo-participante-editar"]');
    const tipoParticipanteInvalidoDiv = document.getElementById('tipo-participante-invalido-editar');
    const representanteRadios = document.querySelectorAll('input[name="representante-editar"]'); // NOVO
    const salvarEdicaoButton = document.getElementById('salvar-edicao');
    const cancelarEdicaoButton = document.getElementById('cancelar-edicao');
    const mensagemEdicaoDiv = document.getElementById('mensagem-edicao');
    const buscarCadastroButton = document.getElementById('buscar-cadastro');
    // --- Listeners de Formatação e Validação ---
    telefoneEditarInput?.addEventListener('input', (e)=>{
        e.target.value = (0, $gGcib.formatarTelefoneInput)(e.target.value);
        if (telefoneInvalidoDiv) telefoneInvalidoDiv.style.display = 'none';
    });
    telefoneEditarInput?.addEventListener('blur', (e)=>{
        const tel = (0, $gGcib.limparNumeros)(e.target.value);
        if (telefoneInvalidoDiv) {
            if (tel && (tel.length < 10 || tel.length > 11)) {
                telefoneInvalidoDiv.textContent = "Celular inv\xe1lido (10 ou 11 d\xedgitos).";
                telefoneInvalidoDiv.style.display = 'block';
            } else telefoneInvalidoDiv.style.display = 'none';
        }
    });
    cpfEditarInput?.addEventListener('input', (e)=>{
        e.target.value = (0, $gGcib.formatarCPFInput)(e.target.value);
        if (cpfInvalidoDiv) cpfInvalidoDiv.style.display = 'none';
    });
    cpfEditarInput?.addEventListener('blur', (e)=>{
        const cpf = (0, $gGcib.limparNumeros)(e.target.value);
        if (cpfInvalidoDiv) {
            if (cpf && !(0, $gGcib.validarCPF)(cpf)) {
                cpfInvalidoDiv.textContent = "CPF inv\xe1lido.";
                cpfInvalidoDiv.style.display = 'block';
            } else cpfInvalidoDiv.style.display = 'none';
        }
    });
    cnpjEditarInput?.addEventListener('input', (e)=>{
        e.target.value = (0, $gGcib.formatarCNPJInput)(e.target.value);
        if (cnpjInvalidoDiv) cnpjInvalidoDiv.style.display = 'none';
    });
    cnpjEditarInput?.addEventListener('blur', (e)=>{
        const cnpj = (0, $gGcib.limparNumeros)(e.target.value);
        if (cnpjInvalidoDiv) {
            if (cnpj && !(0, $gGcib.validarCNPJ)(cnpj)) {
                cnpjInvalidoDiv.textContent = "CNPJ inv\xe1lido.";
                cnpjInvalidoDiv.style.display = 'block';
            } else cnpjInvalidoDiv.style.display = 'none';
        }
    });
    emailEditarInput?.addEventListener('input', ()=>{
        if (emailInvalidoDiv) emailInvalidoDiv.style.display = 'none';
    });
    // --- Buscar Dados do Participante ---
    async function buscarDadosParticipante(cpf) {
        try {
            const { data: participante, error: selectError } = await (0, $cpXHg.supabaseClient).from('participantes').select('*').eq('cpf', cpf).maybeSingle();
            if (selectError) throw selectError;
            if (participante) {
                nomeEditarInput.value = participante.nome;
                telefoneEditarInput.value = participante.telefone;
                cpfEditarInput.value = participante.cpf || '';
                empresaEditarInput.value = participante.empresa || '';
                cnpjEditarInput.value = participante.cnpj || '';
                emailEditarInput.value = participante.email;
                tipoParticipanteRadios.forEach((radio)=>{
                    radio.checked = radio.value === participante.tipo_participante;
                });
                representanteRadios.forEach((radio)=>{
                    radio.checked = radio.value === String(participante.representante); // NOVO
                }); // NOVO
                nomeEditarInput.disabled = false;
                telefoneEditarInput.disabled = false;
                empresaEditarInput.disabled = false;
                cnpjEditarInput.disabled = false;
                emailEditarInput.disabled = false;
                tipoParticipanteRadios.forEach((radio)=>radio.disabled = false);
                representanteRadios.forEach((radio)=>radio.disabled = false); // NOVO
                salvarEdicaoButton.disabled = false;
                mensagemEdicaoDiv.textContent = "Dados carregados. Fa\xe7a as altera\xe7\xf5es e salve.";
                mensagemEdicaoDiv.style.color = 'green';
            } else {
                mensagemEdicaoDiv.textContent = "Participante n\xe3o encontrado.";
                mensagemEdicaoDiv.style.color = 'orange';
                limparEdesabilitarFormulario();
            }
        } catch (error) {
            mensagemEdicaoDiv.textContent = `Erro ao buscar dados: ${error.message}`;
            mensagemEdicaoDiv.style.color = 'red';
            limparEdesabilitarFormulario();
        }
    }
    function limparEdesabilitarFormulario() {
        nomeEditarInput.value = '';
        telefoneEditarInput.value = '';
        cpfEditarInput.value = '';
        empresaEditarInput.value = '';
        cnpjEditarInput.value = '';
        emailEditarInput.value = '';
        tipoParticipanteRadios.forEach((radio)=>radio.checked = false);
        representanteRadios.forEach((radio)=>radio.checked = false); // NOVO
        nomeEditarInput.disabled = true;
        telefoneEditarInput.disabled = true;
        empresaEditarInput.disabled = true;
        cnpjEditarInput.disabled = true;
        emailEditarInput.disabled = true;
        tipoParticipanteRadios.forEach((radio)=>radio.disabled = true);
        representanteRadios.forEach((radio)=>radio.disabled = true); // NOVO
        salvarEdicaoButton.disabled = true;
    }
    buscarCadastroButton?.addEventListener('click', (event)=>{
        event.preventDefault();
        const cpf = (0, $gGcib.limparNumeros)(cpfEditarInput.value);
        if (!cpf || !(0, $gGcib.validarCPF)(cpf)) {
            mensagemEdicaoDiv.textContent = "Por favor, insira um CPF v\xe1lido.";
            mensagemEdicaoDiv.style.color = 'red';
            return;
        }
        mensagemEdicaoDiv.textContent = 'Buscando cadastro...';
        mensagemEdicaoDiv.style.color = 'black';
        buscarDadosParticipante(cpf);
    });
    // --- Salvar Edição ---
    salvarEdicaoButton?.addEventListener('click', async ()=>{
        let hasError = false;
        let errorMessages = [];
        if (!nomeEditarInput.value) errorMessages.push("Nome \xe9 obrigat\xf3rio.");
        if (!telefoneEditarInput.value) errorMessages.push("Celular \xe9 obrigat\xf3rio.");
        else if ((0, $gGcib.limparNumeros)(telefoneEditarInput.value).length < 10 || (0, $gGcib.limparNumeros)(telefoneEditarInput.value).length > 11) {
            if (telefoneInvalidoDiv) {
                telefoneInvalidoDiv.textContent = "Celular inv\xe1lido (10 ou 11 d\xedgitos).";
                telefoneInvalidoDiv.style.display = 'block';
            }
            hasError = true;
        }
        if (!emailEditarInput.value) errorMessages.push("Email \xe9 obrigat\xf3rio.");
        else {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(emailEditarInput.value)) {
                if (emailInvalidoDiv) {
                    emailInvalidoDiv.textContent = "Formato de email inv\xe1lido.";
                    emailInvalidoDiv.style.display = 'block';
                }
                hasError = true;
            }
        }
        if (cpfEditarInput.value && !(0, $gGcib.validarCPF)((0, $gGcib.limparNumeros)(cpfEditarInput.value))) {
            if (cpfInvalidoDiv) {
                cpfInvalidoDiv.textContent = "CPF inv\xe1lido.";
                cpfInvalidoDiv.style.display = 'block';
            }
            hasError = true;
        }
        if (cnpjEditarInput.value && !(0, $gGcib.validarCNPJ)((0, $gGcib.limparNumeros)(cnpjEditarInput.value))) {
            if (cnpjInvalidoDiv) {
                cnpjInvalidoDiv.textContent = "CNPJ inv\xe1lido.";
                cnpjInvalidoDiv.style.display = 'block';
            }
            hasError = true;
        }
        let tipoParticipanteSelecionado = false;
        tipoParticipanteRadios.forEach((radio)=>{
            if (radio.checked) tipoParticipanteSelecionado = true;
        });
        if (!tipoParticipanteSelecionado) {
            if (tipoParticipanteInvalidoDiv) tipoParticipanteInvalidoDiv.style.display = 'block';
            hasError = true;
        }
        if (errorMessages.length > 0 && mensagemEdicaoDiv) {
            mensagemEdicaoDiv.textContent = errorMessages.join(' ');
            mensagemEdicaoDiv.style.color = 'red';
            hasError = true;
        }
        if (hasError) return;
        const nome = nomeEditarInput.value;
        const telefone = (0, $gGcib.limparNumeros)(telefoneEditarInput.value);
        const cpf = (0, $gGcib.limparNumeros)(cpfEditarInput.value) || null;
        const empresa = empresaEditarInput.value || null;
        const cnpj = (0, $gGcib.limparNumeros)(cnpjEditarInput.value) || null;
        const email = emailEditarInput.value;
        let tipoParticipante = '';
        tipoParticipanteRadios.forEach((radio)=>{
            if (radio.checked) tipoParticipante = radio.value;
        });
        let representante = null; // NOVO
        representanteRadios.forEach((radio)=>{
            if (radio.checked) representante = radio.value === 'true'; // NOVO
             // NOVO
        }); // NOVO
        try {
            const { error: updateError } = await (0, $cpXHg.supabaseClient).from('participantes').update({
                nome: nome,
                telefone: telefone,
                cpf: cpf,
                empresa: empresa,
                cnpj: cnpj,
                email: email,
                tipo_participante: tipoParticipante,
                representante: representante // NOVO
            }).eq('cpf', cpf);
            if (updateError) throw updateError;
            mensagemEdicaoDiv.textContent = 'Dados atualizados com sucesso!';
            mensagemEdicaoDiv.style.color = 'green';
        } catch (error) {
            mensagemEdicaoDiv.textContent = `Erro ao atualizar dados: ${error.message}`;
            mensagemEdicaoDiv.style.color = 'red';
        }
    });
    cancelarEdicaoButton?.addEventListener('click', ()=>{
        window.location.href = 'index.html';
    });
    const urlParams = new URLSearchParams(window.location.search);
    const cpfNaUrl = urlParams.get('cpf');
    if (cpfNaUrl) {
        cpfEditarInput.value = cpfNaUrl;
        buscarDadosParticipante(cpfNaUrl);
    }
});


//# sourceMappingURL=editar_cadastro.183c4cc4.js.map
